import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import {
  IonCard,
  IonCardHeader,
  IonText,
  IonCardContent,
  IonGrid,
  IonRow,
  IonCol,
  modalController,
} from '@ionic/vue';

import { ModalOptions } from '@/lib/modal';
import { PropType } from 'vue';
import MyButton from './MyButton.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'MyUtilityModal',
  props: {
  modalOptions: {
    type: Object as PropType<ModalOptions>,
    required: true,
  },
},
  setup(__props) {



const closeModal = (data?: any, role?: string) => {
  modalController.dismiss(data, role);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonCard), { style: {"margin":"0"} }, {
    default: _withCtx(() => [
      _createVNode(_unref(IonCardHeader), {
        color: __props.modalOptions.color ?? 'primary'
      }, {
        default: _withCtx(() => [
          _createElementVNode("h6", {
            style: _normalizeStyle({
          color: `var(--ion-color-${__props.modalOptions.color ?? 'primary'}-contrast)`,
        }),
            class: "ion-no-margin ion-text-center"
          }, _toDisplayString(__props.modalOptions.title), 5)
        ]),
        _: 1
      }, 8, ["color"]),
      _createVNode(_unref(IonCardContent), null, {
        default: _withCtx(() => [
          _createVNode(_unref(IonGrid), { class: "ion-text-center" }, {
            default: _withCtx(() => [
              _createVNode(_unref(IonRow), null, {
                default: _withCtx(() => [
                  _createVNode(_unref(IonCol), null, {
                    default: _withCtx(() => [
                      _createVNode(_unref(IonText), {
                        color: __props.modalOptions.color ?? 'primary'
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(__props.modalOptions.message), 1)
                        ]),
                        _: 1
                      }, 8, ["color"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              (__props.modalOptions.buttons)
                ? (_openBlock(), _createBlock(_unref(IonRow), { key: 0 }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.modalOptions.buttons, (button) => {
                        return (_openBlock(), _createBlock(_unref(IonCol), {
                          key: button.label,
                          "size-sm": Number(12 / __props.modalOptions.buttons.length).toFixed(),
                          "size-xs": "12"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(MyButton, {
                              onClick: ($event: any) => (closeModal(button.data, button.role)),
                              label: button.label,
                              color: button.color,
                              fill: button.fill,
                              expand: "block"
                            }, null, 8, ["onClick", "label", "color", "fill"])
                          ]),
                          _: 2
                        }, 1032, ["size-sm"]))
                      }), 128))
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})